import { SimpleRope } from 'pixijs/mesh/extras';

import type { CanvasRenderer } from 'pixijs/renderer/canvas';
import type { RopeGeometry } from 'pixijs/mesh/extras';

/**
 * Renders the object using the Canvas renderer
 * @protected
 * @method _renderCanvas
 * @memberof PIXI.Mesh#
 * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
 */
SimpleRope.prototype._renderCanvas = function _renderCanvas(renderer: CanvasRenderer): void
{
    if (this.autoUpdate
        || (this.geometry as RopeGeometry)._width !== this.shader.texture.height)
    {
        (this.geometry as RopeGeometry)._width = this.shader.texture.height;
        (this.geometry as RopeGeometry).update();
    }

    if (this.shader.update)
    {
        this.shader.update();
    }

    this.calculateUvs();

    this.material._renderCanvas(renderer, this);
};
